module.exports = __webpack_public_path__ + "img/paper-secret-line.77d7b772.png";